import React from "react";
import { FileMagnifyingGlass } from "@phosphor-icons/react";

export default function EmptyState({ title = "Nothing here yet", description = "", action = null, icon: Icon = FileMagnifyingGlass }) {
    return (
        <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-slate-200 bg-white px-6 py-16 text-center">
            <div className="rounded-full bg-slate-50 p-4 text-slate-400">
                <Icon size={40} weight="duotone" />
            </div>
            <h3 className="font-display text-lg font-semibold text-slate-800">{title}</h3>
            {description && <p className="max-w-sm text-sm text-slate-500">{description}</p>}
            {action}
        </div>
    );
}
